export default {
    INIT    : 0,
    LOADING : 1,
    ERROR   : 2, 
    LOADED  : 3
}